<template>
    <v-container fluid>
    <field-form v-if="item" @save="save" :saving="saving" :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep" :last-editable-step="lastEditableStep" :allow-editable="true" @cancel="cancelWizard()" @click-step="changeStep">
    <template v-if="item && fields.templateUnlayer && productCategories">
    <newsletter-editor class="mb-3" ref="editor"
    :height="height" 
    :campaign="item.id" 
    :newsletter="fields.templateUnlayer" 
    :html.sync="htmltemplate"
    :text.sync="texttemplate" 
    :valid.sync="valid" 
    :specs.sync="fields.templateSpecs"
    :specsNew.sync="fields.templateSpecsNew"
    :specsCategories.sync="fields.templateSpecsCategories" 
    :unsubscribe.sync="unsubscribe"
    :dnsName="item.domain.dnsName"
    :productCategories="productCategories"
    @save="updateTemplate"
     />
    </template>
    <template v-else-if="item && fields.templateUnlayer">
        <v-card class="mb-3">
        <v-card-text>
        <v-row>
            <v-col cols="9">
        <v-row>
        <v-col cols="12" sm="6" md="4" lg="3" xl="2" v-for="i in [0,1,2,3,4,5,6,7,8,9,10,11]" :key="i">
            <v-skeleton-loader type="image"/>
        </v-col>
        </v-row>
            </v-col>
            <v-col>
                <v-skeleton-loader type="list-item-avatar@3" class="mb-1"/>
                <v-skeleton-loader type="actions" class="mb-1"/>
                <v-skeleton-loader type="list-item-avatar@3" class="mb-1"/>
                <v-skeleton-loader type="actions" class="mb-1"/>
            </v-col>
        </v-row>
        </v-card-text>
        </v-card>
    </template>
    <template v-else>
        <template-selector :key="item.id" @select="selectTemplate" />
    </template>
    <confirm-dialog title="dialog.unsaved.title" button-caption="dialog.leave" v-model="leaveDialog" @confirm="confirmLeave(true)" @cancel="confirmLeave(false)">
          {{ $t('dialog.unsaved.text') }}
    </confirm-dialog>
    </field-form>
    <v-row v-else>
        <v-col cols="12" sm="6" md="4" lg="3" xl="2" v-for="i in [0,1,2,3,4,5,6,7,8,9,10,11]" :key="i">
            <v-skeleton-loader type="card" class="mb-1"/>
        </v-col>
    </v-row>
    </v-container>
</template>
<script>

import { mapState } from "vuex";
import {mixin as VueTimers} from 'vue-timers'

import NewsletterEditor from '@/components/NewsletterEditor'
import TemplateSelector from "@/components/TemplateSelector"
import EntityForm from '@/mixins/entity-form'
import ConfirmLeave from '@/mixins/confirm-leave'
import Wizards from "@/mixins/wizards"
import Formatters from "@/mixins/formatters"

export default {
    name: 'Design',
    components: {
        NewsletterEditor,
        TemplateSelector
    },
    mixins: [ ConfirmLeave, EntityForm, Wizards, Formatters, VueTimers ],
    data() {
        return {
            endpoint: 'campaigns',
            tabs: null,
            fields: {
                templateSpecs: null,
                templateSpecsNew: null,
                templateSpecsCategories: null,
                templateUnlayer: null,
                templateSES: null
            },
            valid: true,
            htmltemplate: null,
            texttemplate: null,
            sestemplate: null,
            unsubscribe: true,
        }
    },
    computed: {
        wizardParams() {
            let p = {
            };
            if(this.item) {
                p.medium = this.item.medium?.toLowerCase() || 'email';
            }
            return p;
        },
        height() {
            return Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) - 136 - 90;
        },

        ...mapState('domains', [ 'productCategories' ]),
    },
    watch: {
        item() {
            this.loadCategories();
        },
        htmltemplate() {
            this.getSESTemplate();
        },
        texttemplate() {
            this.getSESTemplate();
        }
    },
    methods: {
        selectTemplate(data) {
            this.fields.templateUnlayer = data;
        },
        loadCategories() {
            if(this.item && !this.productCategories) {
                console.debug('Component loading product categories...');
                this.$store.dispatch('domains/getProductCategories', { domainId: this.item.domainID });
            }
        },
        updateTemplate(data) {
            //console.debug('Updating template...');
            this.fields.templateUnlayer = data;
        },
        getSESTemplate() {
            this.fields.templateSES= {
                HtmlPart: this.htmltemplate,
                TextPart: this.item.textVersion ? this.texttemplate : null
            };
        },
        prepareFields() {
            let validation = true;
            let notificationText = [];
        
            if(!this.fields.templateUnlayer || !this.fields.templateSES) {
                validation = false;
                notificationText.push(this.$t('campaigns.design.errors.notCreated'));
            }
            if(!this.unsubscribe) {
                validation = false;
                notificationText.push(this.$t('campaigns.design.errors.unsubscribe'));
            }
            if(!this.valid) {
                validation = false;
                notificationText.push(this.$t('campaigns.design.errors.macros'));
            }

            if(this.item.scheduleType == 'BACK_TO_CART' && this.fields.templateSpecs.recommendationsCount > 1) {
                validation = false;
                notificationText.push(this.$t('campaigns.design.errors.btcRec'));
            }

            if(!validation) {
                this.$store.dispatch('ui/notify', { error: true, text: this.$t('form.errors.fix', { errors: notificationText.join(' ')}) })
            }
            
            return validation;
        },
        edIcon(type) {
            switch(type) {
                case 'SCHEDULED': return '$scheduled';
                case 'AUTOMATIC': return '$refresh';
                case 'BACK_TO_CART': return '$cart';
            }
        },
        autosave() {
            if(this.item && this.detectChange(this.fields.templateUnlayer, this.item.templateUnlayer)) {
                // There should be no problem with concurrency as the templateUnlayer versions should be the same
                //console.debug('Autosaving...');
                this.$store.dispatch('campaigns/updateFields', { fields: { templateUnlayer: this.fields.templateUnlayer}}).then(()=> {
                    this.$store.dispatch('ui/notify', { text: this.$t('campaigns.design.save.success'), timeout: 1000});
                }).catch(()=> { this.$store.dispatch('ui/notify', { text: this.$t('campaigns.design.save.error'), timeout: 5000 }) });
            }
        }

    },
    created() {
        this.$store.commit('ui/wizard', {value: true });
        this.setLastEditableStep();
        this.loadCategories();
    },
    timers: {
        autosave: { time: 60000, autostart: true, repeat: true }
    }
}
</script>